import { useLocation } from "react-router-dom";
import { cn } from "@fmc-digital/ui";
import { RegistrationFeedbackThankYou } from "@/components/organisms/RegistrationFeedbackThankYou/RegistrationFeedbackThankYou";
import type { RegisterFeedbackLocationState } from "@/pages/register/feedback/register-feedback.navigation";
import {
  registerFeedbackPageStyles,
  registerFeedbackThankYouContentStyles,
} from "./register-feedback.styles";

export function RegisterFeedbackThankYouPage() {
  const location = useLocation();
  const registeredEmail = (location.state as RegisterFeedbackLocationState | null)?.username;

  return (
    <div className={cn(registerFeedbackPageStyles())}>
      <div className={cn(registerFeedbackThankYouContentStyles())}>
        <RegistrationFeedbackThankYou username={registeredEmail} />
      </div>
    </div>
  );
}
